import React from 'react';
import moment from 'moment';
import FieldDefault from '../../../../../components/PDFPage/Inputs/Default';
import * as S from '../styles';

const DAPDependentes = ({ formDependente, index }) => {
    const DATE_FORMAT = 'DD/M/YY';
    return (
        <>
            <S.ContainerDependent>
                <S.NumberDependent>{index + 1} - </S.NumberDependent>
                <S.AlignDependent>
                    <S.GroupFields>
                        <FieldDefault
                            style={{ width: '100%' }}
                            label="Nome Completo:"
                            value={formDependente.nomeCompleto}
                        />
                    </S.GroupFields>

                    <S.GroupFields>
                        <FieldDefault
                            style={{ width: '85px' }}
                            label="Data de Nascimento"
                            value={
                                formDependente.dtNascimento && moment(formDependente.dtNascimento).format(DATE_FORMAT)
                            }
                        />
                        <FieldDefault style={{ width: '30px' }} label="Sexo" value={formDependente.sexo} />
                        <FieldDefault style={{ width: '135px' }} label="CPF" value={formDependente.cpf} />
                        <FieldDefault
                            style={{ width: '140px' }}
                            label="Nº da Declaração de Nascido Vivo"
                            value={formDependente.DeclaracaoNascdoVivo}
                        />
                        <FieldDefault
                            style={{ width: '100%' }}
                            label="Cartão Nacional de Saúde"
                            value={formDependente.numCartaoSus}
                        />
                    </S.GroupFields>

                    <S.GroupFields>
                        <FieldDefault style={{ width: '30px' }} label="EC" value={formDependente.estadoCivil} />
                        <FieldDefault style={{ width: '100px' }} label="GP" value={formDependente.grauParentesco} />
                        <FieldDefault
                            style={{ width: '402px' }}
                            label="Nome Completo da Mãe:"
                            value={formDependente.nomeMae}
                        />
                    </S.GroupFields>
                </S.AlignDependent>
            </S.ContainerDependent>
        </>
    );
};

export default DAPDependentes;
